/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

/**
 * This screen is used to redirect the user to the `redirect_uri` with the `refresh_token` as a query parameter.
 * When `redirect_uri` is not provided, will redirect to `/`.
 * This is used by the other HBF apps to authenticate the user.
 *
 * @name AuthorizeScreen
 * @returns {null}
 */
const AuthorizeScreen = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const { refreshToken } = useSelector((state) => state.auth);

  useEffect(() => {
    if (searchParams.has('redirect_uri')) {
      const uri = new URL(searchParams.get('redirect_uri'));
      uri.searchParams.append('refresh_token', refreshToken);
      window.location.href = uri.toString();
    } else {
      window.location.href = '/';
    }
  }, []);

  return null;
};

export default AuthorizeScreen;
